import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout, LogoutAffiliate } from "../store/actions/AuthActions";

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

//Manejo login para Afiliados/Empleados
export function saveTokenAffiliateInLocalStorage(tokenAffiliate) {
  tokenAffiliate.expireDate = new Date(
    new Date().getTime() + tokenAffiliate.expiresIn * 1000
  );
  localStorage.setItem("userDetailsAfiliate", JSON.stringify(tokenAffiliate));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  localStorage.removeItem("userDetailsAfiliate")
  const tokenDetailsString = localStorage.getItem("userDetails");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}

//check autologin para afiliados
export function checkAutoLoginAffiliate(dispatch, navigate) {
  localStorage.removeItem("userDetails")
  let tokenDetailsaffiliate = localStorage.getItem("userDetailsAfiliate");
  if (!tokenDetailsaffiliate) {
    dispatch(LogoutAffiliate(navigate));
    return;
  }

  tokenDetailsaffiliate = JSON.parse(tokenDetailsaffiliate);
  let expireDate = new Date(tokenDetailsaffiliate.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(LogoutAffiliate(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetailsaffiliate));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}



